import { render, staticRenderFns } from "./MessageText.vue?vue&type=template&id=5635c660&scoped=true&"
import script from "./MessageText.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MessageText.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MessageText.vue?vue&type=style&index=0&id=5635c660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5635c660",
  null
  
)

export default component.exports